import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { FLYBITS } from '../../../constants';
import { withDefaultStyles } from '../../../utils/material-ui/hoc';
import AuthorizationClients from '../components/authorized-clients';
import { TENANT } from '../constants';

class Tenant extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <AuthorizationClients handleAuthorize={this.handleAuthorizeCoreSubmission} />
      </div>
    );
  }
  private handleAuthorizeCoreSubmission = () => {
    window.location.href = FLYBITS.AUTH_HOST + '/oauth2/auth-request?redirect=true&clientId=' + TENANT.DATA_SUBMISSION_CLIENT_ID + '&tenantId=' + this.props.match.params.tenantid
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(Tenant)));



// WEBPACK FOOTER //
// ./src/sub-projects/tenant/containers/content.tsx